export function isIos() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
}